<header class="d-flex flex-wrap align-items-center gap-3 p-3 bg-white border-bottom">
  <a routerLink="/projetos"
    ><img src="assets/img/icons4u-logo-horizontal-cinza.png" alt="icons4u — projetos" width="140"
  /></a>
  <label for="project-context" class="mb-0">Projeto</label>
  <select
    id="project-context"
    class="form-select w-auto"
    style="max-width: 100%"
    [value]="platform.selected"
    (change)="change($event)"
  >
    <option value="" disabled>Selecione um projeto</option>
    @for (p of platform.session?.projects; track p.id) {
      <option [value]="p.id">{{ p.name }}</option>
    }
  </select>
  <span [style.color]="platform.project?.color" class="fw-bold">{{
    platform.project?.name || 'Administração da plataforma'
  }}</span>
  <a class="ms-auto" routerLink="/projetos">Projetos</a>
  @if (platform.canManagePlatform) {
    <a routerLink="/administracao">Administração</a>
  }
  <span>{{ platform.session?.user?.name }}</span
  ><button class="btn btn-outline-secondary" (click)="platform.logout()">Sair</button>
  @if (platform.error || error) {
    <p role="alert">{{ platform.error || error }}</p>
  }
</header>
